import { KeyValueModel } from "model";
import { EnumTpPagamento } from "model/enums/enum-tp-pagamento";

export const TpPagamentoMock: KeyValueModel[] = [
    new KeyValueModel(EnumTpPagamento.TED, 'TED'),
    new KeyValueModel(EnumTpPagamento.CC, 'CC'),
]